export default "__VITE_ASSET__3dz_3sLl__"